// "use client";

// import React, { useState, useEffect } from "react";
// import Sidebar from "../../../Components/Sidebar";
// import TopNav from "../../../Components/TopNav";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import moment from "moment";
// import NoRecordFound from "../../../Components/NoRecordFound";

// // 👇 apni service import karo
// import {  getProductNotifyQueryServ } from "../../../services/support.service";

// const ProductNotify = () => {
//   const [list, setList] = useState([]);
//   const [statics, setStatics] = useState(null);

//   const [payload, setPayload] = useState({
//     searchKey: "",
//     pageNo: 1,
//     pageCount: 25,
//     sortByField: "",
//   });

//   const [showSkelton, setShowSkelton] = useState(false);

//   const filteredList = list?.filter((item) => {

//   const search = payload?.searchKey?.toLowerCase();

//   return (
//     item?.productName?.toLowerCase()?.includes(search) ||
//     item?.emailOrPhone?.toLowerCase()?.includes(search) ||
//     item?.productId?.toLowerCase()?.includes(search)
//   );

// });

  
//   // GET PRODUCT NOTIFY LIST
//   const handleGetNotifyList = async () => {
//     if (list.length === 0) {
//       setShowSkelton(true);
//     }

//     try {
//       const response = await getProductNotifyQueryServ();

//       console.log("notify response", response);

//       setList(response?.data?.data || []);
//       setStatics(response?.data?.documentCount);
//     } catch (error) {
//       console.log("error in notify list", error);
//       toast.error("Failed to fetch notify list");
//     }

//     setShowSkelton(false);
//   };

//   useEffect(() => {
//     handleGetNotifyList();
//   }, [payload]);

//   // ─────────────────────────────────────────────────────────────
//   // STATICS
//   // ─────────────────────────────────────────────────────────────
//   const staticsArr = [
//     {
//       title: "Stock Notify Queries",
//       count: statics?.productNotifyQueries || list?.length || 0,
//       bgColor: "#a60808",
//     },
//   ];

//   return (
//     <div className="bodyContainer">
//       <Sidebar
//         selectedMenu={"System Support"}
//         selectedItem={"product Stock Query"}
//       />

//       <div className="mainContainer">
//         <TopNav />

//         <div className="p-lg-4 p-md-3 p-2">
//           {/* TOP CARDS */}
//           <div
//             className="row mx-0 p-0"
//             style={{
//               position: "relative",
//               top: "-75px",
//               marginBottom: "-75px",
//             }}
//           >
//             {staticsArr?.map((v, i) => {
//               return (
//                 <div className="col-md-4 col-12" key={i}>
//                   <div className="topCard shadow-sm py-4 px-3 rounded mb-3">
//                     <div className="d-flex align-items-center">
//                       <div
//                         className="p-2 shadow rounded"
//                         style={{ background: v?.bgColor }}
//                       >
//                         <img
//                           src="https://cdn-icons-png.flaticon.com/128/1827/1827392.png"
//                           alt="notify"
//                         />
//                       </div>

//                       <div className="ms-3">
//                         <h6>{v?.title}</h6>
//                         <h2 className="text-secondary">{v?.count}</h2>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           {/* HEADER */}
//           <div className="row m-0 p-0 d-flex align-items-center my-4 justify-content-between topActionForm">
//             <div className="col-lg-4 mb-2 col-md-12 col-12">
//               <h3 className="mb-0 text-bold text-secondary">
//                 Product Stock Notify Queries
//               </h3>
//             </div>

//             {/* SEARCH */}
//             <div className="col-lg-4 mb-2 col-md-6 col-12">
//               <input
//                 type="text"
//                 className="form-control borderRadius24"
//                 placeholder="Search by product / email / phone"
//                 value={payload?.searchKey}
//                 onChange={(e) =>
//                   setPayload({
//                     ...payload,
//                     searchKey: e.target.value,
//                   })
//                 }
//               />
//             </div>
//           </div>

//           {/* TABLE */}
//           <div className="mt-3">
//             <div className="card-body px-2">
//               <div className="table-responsive table-invoice">
//                 <table className="table">
//                   <tbody>
//                     {/* HEADER */}
//                     <tr
//                       style={{
//                         background: "#F3F3F3",
//                         color: "#000",
//                       }}
//                     >
//                       <th
//                         className="text-center py-3"
//                         style={{
//                           borderRadius: "30px 0px 0px 30px",
//                         }}
//                       >
//                         Sr. No
//                       </th>

//                       <th className="text-center py-3">
//                         Product Name
//                       </th>

//                       <th className="text-center py-3">
//                         Email / Phone
//                       </th>

//                       <th className="text-center py-3">
//                         Product Id
//                       </th>

//                       <th className="text-center py-3">
//                         Created At
//                       </th>

                  
//                     </tr>

//                     <div className="py-2"></div>

//                     {/* SKELETON */}
//                     {showSkelton
//                       ? [1, 2, 3, 4, 5, 6]?.map((v, i) => {
//                           return (
//                             <React.Fragment key={i}>
//                               <tr>
//                                 <td className="text-center">
//                                   <Skeleton width={40} height={25} />
//                                 </td>

//                                 <td className="text-center">
//                                   <Skeleton width={120} height={25} />
//                                 </td>

//                                 <td className="text-center">
//                                   <Skeleton width={180} height={25} />
//                                 </td>

//                                 <td className="text-center">
//                                   <Skeleton width={120} height={25} />
//                                 </td>

//                                 <td className="text-center">
//                                   <Skeleton width={120} height={25} />
//                                 </td>

//                                 <td className="text-center">
//                                   <Skeleton width={80} height={25} />
//                                 </td>
//                               </tr>

//                               <div className="py-2"></div>
//                             </React.Fragment>
//                           );
//                         })
//                       : filteredList?.map((v, i) => {
//                           return (
//                             <React.Fragment key={v?._id || i}>
//                               <tr>
//                                 {/* SERIAL */}
//                                 <td className="text-center">
//                                   {i + 1}
//                                 </td>

//                                 {/* PRODUCT */}
//                                 <td className="font-weight-600 text-center">
//                                   {v?.productName || "N/A"}
//                                 </td>

//                                 {/* CONTACT */}
//                                 <td className="font-weight-600 text-center">
//                                   {v?.emailOrPhone || "N/A"}
//                                 </td>

//                                 {/* PRODUCT ID */}
//                                 <td className="font-weight-600 text-center">
//                                   <div
//                                     style={{
//                                       maxWidth: "180px",
//                                       wordBreak: "break-word",
//                                       margin: "auto",
//                                     }}
//                                   >
//                                     {v?.productId || "N/A"}
//                                   </div>
//                                 </td>

//                                 {/* DATE */}
//                                 <td className="font-weight-600 text-center">
//                                   {v?.createdAt
//                                     ? moment(v?.createdAt).format(
//                                         "DD MMM YYYY hh:mm A"
//                                       )
//                                     : "N/A"}
//                                 </td>

//                                 {/* STATUS */}
//                                 {/* <td className="text-center">
//                                   <button
//                                     className="badge"
//                                     style={{
//                                       height: "30px",
//                                       background: "#a60808",
//                                       border: "none",
//                                     }}
//                                   >
//                                     Pending
//                                   </button>
//                                 </td> */}
//                               </tr>

//                               <div className="py-2"></div>
//                             </React.Fragment>
//                           );
//                         })}
//                   </tbody>
//                 </table>

//                 {/* NO RECORD */}
//               {filteredList?.length === 0 && !showSkelton && (
//                   <NoRecordFound />
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductNotify;


"use client";

import React, { useState, useEffect } from "react";
import Sidebar from "../../../Components/Sidebar";
import TopNav from "../../../Components/TopNav";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import NoRecordFound from "../../../Components/NoRecordFound";

// SERVICE
import { getProductNotifyQueryServ } from "../../../services/support.service";

/* ─── Scoped Styles ───────────────────────── */
const styles = `
  .pn-page {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'Segoe UI', sans-serif;
  }

  /* stat card */
  .pn-stat-grid {
    display: grid;
    grid-template-columns: repeat(1, 340px);
    gap: 18px;
    margin-bottom: 22px;
  }

  @media (max-width: 768px) {
    .pn-stat-grid {
      grid-template-columns: 1fr;
    }
  }

  .pn-stat-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .pn-stat-icon {
    width: 58px;
    height: 58px;
    border-radius: 16px;
    background: #fdf2f1;
    color: #a60808;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    flex-shrink: 0;
  }

  .pn-stat-title {
    font-size: 15px;
    color: #888;
    margin-bottom: 6px;
    font-weight: 500;
  }

  .pn-stat-count {
    font-size: 32px;
    font-weight: 700;
    color: #1c0a0a;
    line-height: 1;
  }

  /* toolbar */
  .pn-toolbar {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    padding: 18px 22px;
    margin-bottom: 18px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }

  .pn-toolbar-title {
    font-size: 19px;
    font-weight: 700;
    color: #1c0a0a;
  }

  .pn-search-wrap {
    position: relative;
  }

  .pn-search-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #a60808;
    font-size: 16px;
  }

  .pn-search {
    width: 350px;
    height: 48px;
    border-radius: 12px;
    border: 1px solid #f0eded;
    background: #fafafa;
    padding: 0 16px 0 42px;
    font-size: 15px;
    color: #444;
    outline: none;
    transition: all 0.18s ease;
  }

  .pn-search:focus {
    border-color: #f0c0b8;
    background: #fff;
  }

  @media (max-width: 768px) {
    .pn-search {
      width: 100%;
    }

    .pn-search-wrap {
      width: 100%;
    }
  }

  /* table */
  .pn-table-wrap {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }

  .pn-table-scroll {
    overflow-x: auto;
  }

  .pn-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 1050px;
  }

  .pn-table thead tr {
    background: #fdf2f1;
  }

  .pn-table th {
    padding: 18px 20px;
    text-align: left;
    font-size: 14px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    white-space: nowrap;
  }

  .pn-table td {
    padding: 20px;
    color: #444;
    border-top: 1px solid #f7f5f5;
    vertical-align: middle;
    font-size: 16px;
  }

  .pn-table tbody tr:hover td {
    background: #fdfafa;
  }

  .pn-serial {
    color: #999;
    font-weight: 600;
    width: 80px;
  }

  .pn-product-cell {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .pn-product-avatar {
    width: 48px;
    height: 48px;
    border-radius: 14px;
    background: #fdf2f1;
    color: #a60808;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
  }

  .pn-product-name {
    font-size: 16px;
    font-weight: 600;
    color: #222;
    line-height: 1.5;
  }

  .pn-contact {
    font-size: 15px;
    color: #555;
    font-weight: 500;
  }

  .pn-product-id {
    max-width: 220px;
    word-break: break-word;
    font-size: 14px;
    line-height: 1.6;
    color: #777;
    background: #fafafa;
    border: 1px solid #f3f1f1;
    padding: 10px 12px;
    border-radius: 10px;
  }

  .pn-date {
    font-size: 15px;
    color: #777;
    white-space: nowrap;
  }

  .pn-empty {
    padding: 42px 20px;
  }
`;

const ProductNotify = () => {
  const [list, setList] = useState([]);
  const [statics, setStatics] = useState(null);

  const [payload, setPayload] = useState({
    searchKey: "",
    pageNo: 1,
    pageCount: 25,
    sortByField: "",
  });

  const [showSkelton, setShowSkelton] = useState(false);

  const filteredList = list?.filter((item) => {
    const search = payload?.searchKey?.toLowerCase();

    return (
      item?.productName?.toLowerCase()?.includes(search) ||
      item?.emailOrPhone?.toLowerCase()?.includes(search) ||
      item?.productId?.toLowerCase()?.includes(search)
    );
  });

  // GET PRODUCT NOTIFY LIST
  const handleGetNotifyList = async () => {
    if (list.length === 0) {
      setShowSkelton(true);
    }

    try {
      const response = await getProductNotifyQueryServ();

      console.log("notify response", response);

      setList(response?.data?.data || []);
      setStatics(response?.data?.documentCount);
    } catch (error) {
      console.log("error in notify list", error);
      toast.error("Failed to fetch notify list");
    }

    setShowSkelton(false);
  };

  useEffect(() => {
    handleGetNotifyList();
  }, [payload]);

  // INITIALS
  const getInitials = (name = "") => {
    return (
      name
        ?.split(" ")
        ?.map((n) => n[0])
        ?.join("")
        ?.toUpperCase()
        ?.slice(0, 2) || "P"
    );
  };

  // STATICS
  const staticsArr = [
    {
      title: "Stock Notify Queries",
      count:
        statics?.productNotifyQueries ||
        list?.length ||
        0,
    },
  ];

  return (
    <div className="bodyContainer">
      <style>{styles}</style>

      <Sidebar
        selectedMenu={"System Support"}
        selectedItem={"product Stock Query"}
      />

      <div className="mainContainer">

        <TopNav
          pageTitle="Product Notify Queries"
          pagePath="Home / System Support / Product Notify Query"
        />

        <div className="pn-page">

          {/* ── Stats ── */}
          <div className="pn-stat-grid">

            {staticsArr?.map((v, i) => (
              <div className="pn-stat-card" key={i}>

                <div className="pn-stat-icon">
                  <i className="ti ti-bell-ringing" />
                </div>

                <div>
                  <div className="pn-stat-title">
                    {v?.title}
                  </div>

                  <div className="pn-stat-count">
                    {v?.count}
                  </div>
                </div>

              </div>
            ))}

          </div>

          {/* ── Toolbar ── */}
          <div className="pn-toolbar">

            <div className="pn-toolbar-title">
              Product Stock Notify Queries
            </div>

            {/* SEARCH */}
            <div className="pn-search-wrap">

              <i className="ti ti-search pn-search-icon" />

              <input
                type="text"
                className="pn-search"
                placeholder="Search by product / email / phone"
                value={payload?.searchKey}
                onChange={(e) =>
                  setPayload({
                    ...payload,
                    searchKey: e.target.value,
                  })
                }
              />

            </div>

          </div>

          {/* ── Table ── */}
          <div className="pn-table-wrap">

            <div className="pn-table-scroll">

              <table className="pn-table">

                <thead>
                  <tr>
                    <th>#</th>
                    <th>Product Name</th>
                    <th>Email / Phone</th>
                    <th>Product Id</th>
                    <th>Created At</th>
                  </tr>
                </thead>

                <tbody>

                  {/* Skeleton */}
                  {showSkelton ? (
                    [...Array(6)]?.map((_, i) => (
                      <tr key={i}>

                        {[1, 2, 3, 4, 5].map((v) => (
                          <td key={v}>
                            <Skeleton height={24} />
                          </td>
                        ))}

                      </tr>
                    ))
                  ) : filteredList?.length > 0 ? (
                    filteredList?.map((v, i) => (
                      <tr key={v?._id || i}>

                        {/* SERIAL */}
                        <td className="pn-serial">
                          {i + 1}
                        </td>

                        {/* PRODUCT */}
                        <td>

                          <div className="pn-product-cell">

                            <div className="pn-product-avatar">
                              {getInitials(v?.productName)}
                            </div>

                            <div className="pn-product-name">
                              {v?.productName || "N/A"}
                            </div>

                          </div>

                        </td>

                        {/* CONTACT */}
                        <td>

                          <div className="pn-contact">
                            {v?.emailOrPhone || "N/A"}
                          </div>

                        </td>

                        {/* PRODUCT ID */}
                        <td>

                          <div className="pn-product-id">
                            {v?.productId || "N/A"}
                          </div>

                        </td>

                        {/* DATE */}
                        <td>

                          <div className="pn-date">
                            {v?.createdAt
                              ? moment(v?.createdAt).format(
                                  "DD MMM YYYY hh:mm A"
                                )
                              : "N/A"}
                          </div>

                        </td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                        className="pn-empty"
                      >
                        <NoRecordFound />
                      </td>
                    </tr>
                  )}

                </tbody>

              </table>

            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default ProductNotify;